@use "../../../../../../styles/Constants.scss" as Constants;
@use "../../../../../../styles/Colors.scss" as Colors;

.assignment-history-table-container {
	padding: Constants.$val-spacing-xs Constants.$val-spacing-s;
	width: 100%;
}

.assignment-history-table {
	width: 100%;
	background-color: Colors.$col-design-gray50;
	border-spacing: Constants.$val-spacing-m 0;
}

.assignment-history-header {
	border-top: 1px solid Colors.$col-design-gray300;
	border-bottom: 1px solid Colors.$col-design-gray300;

	th {
		padding: Constants.$val-spacing-s 0;
		color: Colors.$col-design-gray300;
		font-weight: 400;
		font-size: Constants.$val-fontSizeRegular;
	
		&:first-child {
		  padding-left: Constants.$val-spacing-m;
		}

		&:nth-child(2) {
			padding-left: Constants.$val-spacing-m;
		}
	
		&:last-child {
		  padding-right: Constants.$val-spacing-m;
		}
	}
}

.assignment-history-row {
	border-bottom: 1px solid Colors.$col-design-gray300;

	td {
		padding: Constants.$val-spacing-s 0;
		word-break: normal;
		white-space: normal;
		color: Colors.$col-design-gray900;
		font-weight: 400;
		font-size: Constants.$val-fontSizeRegular;
		
		&:first-child {
			padding-left: Constants.$val-spacing-m;
		}
		
		&:nth-child(2) {
			padding-left: Constants.$val-spacing-m;
		}
		
		&:last-child {
			padding-right: Constants.$val-spacing-m;
		}
	}
	
	&__reason {
		font-size: Constants.$val-fontSizeSmall !important;
	}
}

.loading-container {
	text-align: center;
	margin-top: Constants.$val-spacing-l;
	margin-bottom: Constants.$val-spacing-l;
}
